import { render, staticRenderFns } from "./IntegrationsInfo.vue?vue&type=template&id=304e1acb"
import script from "./IntegrationsInfo.vue?vue&type=script&lang=js"
export * from "./IntegrationsInfo.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsInfo.vue?vue&type=style&index=0&id=304e1acb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports